import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { BlockUIModule } from 'primeng/blockui';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { RippleModule } from 'primeng/ripple';
import { MenuModule } from 'primeng/menu';
import { ThemeToggleComponent } from '../../shared/components/theme-toggle/theme-toggle.component';
import { NavigationEnd, Router } from '@angular/router';
import {
  LOGIN_METHOD_KEY,
  LoginMethod,
} from 'src/app/core/enums/login-method.enum';
import { Role } from 'src/app/core/enums/role.enum';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        MenuModule,
        RippleModule,
        StyleClassModule,
        ButtonModule,
        BadgeModule,
        BlockUIModule,
        ThemeToggleComponent,
    ]
})
export class HeaderComponent implements OnInit{
  public readonly authService = inject(AuthService);
  private router = inject(Router);
  loggingOut = false;

  showContent = signal<boolean>(true);

  ngOnInit(): void {
    this.showContent.set(!this.router.url.includes('/help'));

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showContent.set(!event.url.includes('/help'));
      }
    });
  }

  userRole() {
    const loginMethod = localStorage.getItem(LOGIN_METHOD_KEY) as LoginMethod;
    let hasAdmin = false;

    if (loginMethod === LoginMethod.IAM) {
      const roles = this.authService.user()?.role;
      hasAdmin = roles?.includes(Role.Administrator) || false;
    } else if (loginMethod === LoginMethod.Identity) {
      hasAdmin = this.authService.identityUser()?.roles?.includes(Role.Administrator) || false;
    }

    return hasAdmin ? Role.Administrator : Role.Monitor;
  }

  userCardItems = computed(() => {
    const items = [
      {
        label: 'Profile',
        icon: 'pi pi-user',
        routerLink: 'profile',
      },
      {
        label: 'Help',
        icon: 'pi pi-question',
        command: () => {
          this.openHelpWindow();
        },
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => {
          this.authService.logout();
        },
      },
    ];

    // items.unshift({
    //   label: 'Profile',
    //   icon: 'pi pi-user',
    //   routerLink: 'profile',
    // });

    return items;
  });

  openHelpWindow() {
    const currentUrl = this.router.url;

    this.router
      .navigate(['/help'])
      .then((result) => {
        if (result) {
          window.open(`/emu/ui/help/introduction`, '_blank');
          this.router.navigate([currentUrl]);
        }
      })
      .catch((error) => {
        console.error('Navigation error:', error);
      });
  }
}
